import { render, staticRenderFns } from "./ClassificationDegreeInfo.vue?vue&type=template&id=33ffd6c6&"
import script from "./ClassificationDegreeInfo.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports